var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 27.44V30.016C57.9965 36.054 56.0414 41.9291 52.4261 46.7651C48.8109 51.6011 43.7292 55.1389 37.939 56.8509C32.1488 58.5629 25.9603 58.3573 20.2965 56.2648C14.6327 54.1724 9.79703 50.3051 6.51069 45.2398C3.22435 40.1745 1.66342 34.1826 2.06069 28.1577C2.45797 22.1328 4.79218 16.3977 8.71518 11.8078C12.6382 7.21792 17.9398 4.0191 23.8293 2.68844C29.7189 1.35777 35.8807 1.96657 41.396 4.42403M58 7.6L30 35.628L21.6 27.228",
    stroke: "#00D274",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkMark.492db92d.svg";
export { ForwardRef as ReactComponent };